// extracted by mini-css-extract-plugin
module.exports = {"dialog":"CenterPickerDialog_dialog__2CHCQ"};